import React from "react";

export default function VisionMission() {
  const html = `<div class="container">
<div class="row row-cols-1 row-cols-sm-2 row-cols-md-1 g-1">
<div class="container-md">
<span class="style1"><b>VISION</b></span>
<div class="card shadow-sm">
<p>
Our vision is to be a leading institution in teacher education, empowering future educators to create dynamic and inclusive learning environments. We strive to produce skilled, compassionate, and innovative teachers who can foster intellectual, emotional, and social development in students, ultimately contributing to the betterment of society.
</p>
</div>
</div>
<div class="container-md">
<span class="style1"><b>MISSION</b></span>
<div class="card shadow-sm">
<ul class="bullet-list">
<li>Provide high-quality teacher education that equips our students with contemporary pedagogical skills, professional ethics, and a passion for lifelong learning.</li>
<li>Foster an environment that promotes critical thinking, creativity, and educational innovation.</li>
<li>Empower our students with the tools to be inclusive educators who are sensitive to diverse student needs and can integrate technology effectively into their teaching practices.</li>
<li>Encourage collaboration, research, and community engagement to ensure holistic professional development.</li>
</ul>
</div>
</div>
<div class="container-md">
<span class="style1"><b>OBJECTIVES</b></span>
<div class="card shadow-sm">
<ul class="bullet-list">
<li>To develop competent educators who are equipped with modern teaching methods and practices.</li>
<li>To nurture leadership skills and ethical values in aspiring teachers, enabling them to be role models for their students.</li>
<li>To promote research and continuous professional development in the field of education.</li>
<li>To create inclusive educators capable of addressing the diverse needs of students in today’s classrooms.</li>
<li>To ensure that our students are well-versed in the use of technology and digital tools in teaching and learning.</li>
<li>To foster a spirit of service and community engagement in all our students, encouraging them to contribute positively to society.</li>
</ul>
</div>
</div>
</div>
</div>`;
  return (
    <div className="container my-4">
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
